import { Component, NgZone, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CartService } from '../../../cart/services/cart.service';
import { CollectionsService } from '../../../collections/service/collections.service';
import { DataService } from '../../../../core/services/data.service';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import i18next from 'i18next';
import { ToastrService } from 'ngx-toastr';
import { EmptyCart } from '../../../cart/store/actions/cart.actions';
import { AuthService } from '../../../../core/services/auth.service';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { getCurrencySymbol } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsService } from 'src/core/services/analytics.service';
import { environment } from 'src/environments/environment';
import { BridgeMode } from '@hg-com/xwc-js-bridge';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  offCanvasOpen = false;
  cartOpen = false;
  cartItemAmount: number = 0;
  priceActive = true;
  searchOpen = false;
  priceLists: string[] = [];
  selectedPriceList = localStorage.getItem('priceListActive');
  priceListTxt!: string;
  priceListNameKeys!: any;
  dataLoaded = this.collectionsService.dataLoaded;
  currentApplicationVersion = environment.appVersion;
  contextNative!: boolean;
  pricesVisibility!: boolean;
  lang!: string;
  currencySymbol!: string;
  private subscriptions: Subscription = new Subscription();
  subscription!: Subscription;
  nativeEnv = false;

  constructor(
    private cartService: CartService,
    private store: Store<{ cart: any }>,
    public collectionsService: CollectionsService,
    public dataService: DataService,
    private router: Router,
    private modalService: ModalService,
    private authService: AuthService,
    private toastr: ToastrService,
    private nis: NativeIntegrationService,
    private ngZone: NgZone,
    private domSanitizer: DomSanitizer,
    private analyticsService: AnalyticsService
  ) {
    if (this.nis.native.mode > BridgeMode.Mock) {
      this.nativeEnv = true;
    }
    const collectionDataSub =
      this.collectionsService.loadDataObservable$.subscribe(() => {
        this.serveData();
      });
    this.subscriptions.add(collectionDataSub);
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }

    this.currencySymbol = getCurrencySymbol(
      this.collectionsService.currencyCode,
      'narrow'
    );
    this.lang = i18next.language;
    this.subscription = this.authService.communityToken.subscribe((x) => {
      this.ngZone.run(() => (this.communityData = x));
    });
  }

  serveData(): void {
    this.contextNative = this.authService.contextNative$.value;
    this.priceListTxt = this.dataService.dataPriceLists.texts.priceInfo;

    const cartOpenSub = this.cartService.cartOpen$.subscribe((value) => {
      this.cartOpen = value;
    });
    this.subscriptions.add(cartOpenSub);
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);
    const cart = this.store.select('cart');
    const cartSub = cart.subscribe(
      (cartItems) => (this.cartItemAmount = cartItems.length)
    );
    this.subscriptions.add(cartSub);
    this.priceLists = this.dataService.priceLists.sort((a, b) =>
      a.localeCompare(b)
    );
    this.priceListNameKeys = this.dataService.context.priceListNameKeys;
    console.log(this.priceListNameKeys);
    console.log(this.priceLists);
    this.pricesVisibility = this.dataService.context.prices;
    if (!this.pricesVisibility) {
      this.cartService.priceActive$.next(false);
    }
  }

  handleMenu(): void {
    this.offCanvasOpen = !this.offCanvasOpen;
  }

  handleCart(): void {
    this.vibrate();
    if (!this.cartOpen) {
      this.analyticsService.trackEvent({
        event: 'virtualpageview',
        page: '/applic/bpl-app/virtual/show-digital-bag',
        category: 'bpl app',
      });
    }
    this.cartService.cartOpen$.next(!this.cartOpen);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.subscription.unsubscribe();
  }

  handlePriceActiv(): void {
    this.cartService.priceActive$.next(!this.priceActive);
  }

  openSearch(): void {
    this.searchOpen = !this.searchOpen;
  }

  changePriceList(priceList: string, i: number): void {
    this.selectedPriceList = priceList;
    localStorage.setItem('priceListActive', priceList);
    this.dataService.changePriceList(priceList);
    this.router.navigate(['/home']);
    this.emptyCart();
    this.handleMenu();
    this.closeModal('change-pricelist-modal-' + i);
    this.toastr.success(
      i18next.t('menu.pricelist-update') + '<strong>' + priceList + '</strong>'
    );
  }

  openModal(id: string): void {
    this.modalService.open(id);
  }

  closeModal(id: string): void {
    this.modalService.close(id);
  }

  emptyCart(): void {
    this.store.dispatch(EmptyCart());
  }

  vibrate(): void {
    this.nis.hapticFeedback();
  }

  logout(): void {
    console.log('Manual logout');
    this.dataService.logout();
  }

  communityData: {
    osit: string;
    sid: string;
    username: string;
  } | null = null;

  openB2bRegisterNative() {
    this.nis.basics.openExternalBrowser$(
      'https://pro.villeroy-boch.com/de/de/dining-lifestyle/servicewelt-registrierung'
    );
  }

  b2bShopLink() {
    if (!this.communityData) {
      return null;
    }
    return this.domSanitizer.bypassSecurityTrustUrl(
      `${environment.servicePortal}/login?userName=${encodeURIComponent(
        this.communityData.username
      )}&authToken=${encodeURIComponent(
        this.communityData.osit
      )}&sid=${encodeURIComponent(
        this.communityData.sid
      )}&startURL=${encodeURIComponent('/account/carts')}`
    );
  }

  openB2bNative() {
    if (!this.communityData) {
      return;
    }
    this.nis.basics.openExternalBrowser$(
      `${environment.servicePortal}/login?userName=${encodeURIComponent(
        this.communityData.username
      )}&authToken=${encodeURIComponent(
        this.communityData.osit
      )}&sid=${encodeURIComponent(
        this.communityData.sid
      )}&startURL=${encodeURIComponent('/account/carts')}`
    );
  }
}
